// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SpinnerSvg from '../icons/status/Spinner';
var Spinner = createSvgIcon({
    as: SpinnerSvg,
    ariaLabel: 'spinner',
    category: 'status',
    displayName: 'Spinner'
});
export default Spinner;
